<template>
  <div class="container py-5">
    <div class="d-flex flex-column flex-md-row align-items-md-center justify-content-between mb-4 gap-3">
      <div>
        <h2 class="mb-1 fw-bold text-primary">
          <i class="bi bi-briefcase-fill me-2"></i>Vagas Disponíveis
        </h2>
        <p class="text-muted mb-0">Encontre e filtre oportunidades abertas</p>
      </div>
    </div>

    <div class="card shadow-sm mb-4 border-0 rounded-4">
      <div class="card-body pb-2">
        <div class="row g-2">
          <div
            class="col-12 col-sm-6 col-md-4 col-lg-3"
            v-for="(label, campo) in labels"
            :key="campo"
          >
            <div class="input-group input-group-sm">
              <span class="input-group-text bg-light border-0">
                <i :class="icons[campo] || 'bi bi-search'"></i>
              </span>
              <input
                :placeholder="label"
                v-model="filtros[campo]"
                class="form-control border-0 shadow-none"
                style="background: #f8f9fa"
              />
              <button
                v-if="filtros[campo]"
                class="btn btn-light border-0 px-2"
                type="button"
                @click="filtros[campo]=''"
                title="Limpar filtro"
                style="margin-left:-2px"
              >
                <i class="bi bi-x-circle text-secondary"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="table-responsive rounded-4 shadow-sm">
      <table class="table table-hover table-striped align-middle mb-0">
        <thead class="table-primary">
          <tr>
            <th>Título</th>
            <th>Local</th>
            <th>Unidade Cultural <br> Núcleo</th>
            <th>Formato</th>
            <th>Modalidade</th>
            <th>Jornada</th>
            <th>Faixa Salarial</th>
            <th>Prazo</th>
            <th>Status</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="vaga in vagasFiltradas" :key="vaga.id">
            <td class="fw-semibold">{{ vaga.titulo }}</td>
            <td>{{ vaga.local_trabalho }}</td>
            <td>{{ vaga.nucleo_regional }}</td>
            <td>{{ vaga.formato }}</td>
            <td>{{ vaga.modalidade_contratacao }}</td>
            <td>{{ vaga.jornada }}</td>
            <td>{{ vaga.faixa_salarial }}</td>
            <td>
              <span class="badge bg-light text-dark border">
                {{ formatarDataBrasileira(vaga.prazo?.substr(0, 10)) }}
              </span>
            </td>
            <td>
              <span :class="{
                'badge bg-success': vaga.statuss === 'aberta',
                'badge bg-danger': vaga.statuss !== 'aberta'
              }">
                {{ vaga.statuss }}
              </span>
            </td>
            <td>
              <router-link
                :to="`/vaga/${vaga.id}`"
                class="btn btn-sm btn-outline-primary"
                title="Ver detalhes"
              >
                <i class="bi bi-eye"></i>
              </router-link>
            </td>
          </tr>
          <tr v-if="vagasFiltradas.length === 0">
            <td colspan="10" class="text-center text-muted py-4">
              <i class="bi bi-emoji-frown fs-3"></i><br>
              Nenhuma vaga encontrada.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import api from '../services/api';

export default {
  name: 'HomeVie',
  data() {
    return {
      vagas: [],
      filtros: {
        titulo: '',
        local_trabalho: '',
        nucleo_regional: '',
        formato: '',
        modalidade_contratacao: '',
        jornada: '',
        faixa_salarial: '',
      },
      labels: {
        titulo: 'Título',
        local_trabalho: 'Local',
        nucleo_regional: 'Núcleo Regional',
        formato: 'Formato',
        modalidade_contratacao: 'Modalidade',
        jornada: 'Jornada',
        faixa_salarial: 'Faixa Salarial',
      },
      icons: {
        titulo: 'bi bi-type',
        local_trabalho: 'bi bi-geo-alt',
        nucleo_regional: 'bi bi-diagram-3',
        formato: 'bi bi-laptop',
        modalidade_contratacao: 'bi bi-briefcase',
        jornada: 'bi bi-clock-history',
        faixa_salarial: 'bi bi-cash-coin',
      }
    };
  },
  computed: {
    vagasFiltradas() {
      const filtradas = this.vagas.filter(vaga => {
        return Object.keys(this.filtros).every(campo => {
          if (!this.filtros[campo]) return true;
          const valor = (vaga[campo] || '').toString().toLowerCase();
          return valor.includes(this.filtros[campo].toLowerCase());
        });
      });

      // Destaque da vaga com ID 123
      const destaque = filtradas.find(v => v.id == 1);
      const outras = filtradas.filter(v => v.id != 1);

      return destaque ? [destaque, ...outras] : outras;
    }
  },
  async mounted() {
    try {
      const res = await api.get('listar_vagas.php');
      this.vagas = res.data;
    } catch (e) {
      this.vagas = [];
    }
  },
  methods: {
    formatarDataBrasileira(dataISO) {
      if (!dataISO) return '';
      const [ano, mes, dia] = dataISO.split('-');
      return `${dia}/${mes}/${ano}`;
    }
  }
};
</script>

<style scoped>
.table thead th {
  vertical-align: middle;
  white-space: nowrap;
}
.table td, .table th {
  vertical-align: middle;
}
.input-group-text {
  min-width: 2.2rem;
  justify-content: center;
}
.card {
  background: #f8f9fa;
}

/* Responsividade dos filtros */
@media (max-width: 991.98px) {
  .card-body .row > div {
    flex: 0 0 50%;
    max-width: 50%;
  }
}
@media (max-width: 767.98px) {
  .card-body .row > div {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .table-responsive {
    border-radius: 0.5rem;
    overflow-x: auto;
  }
  .table th, .table td {
    font-size: 0.95rem;
    padding: 0.5rem;
  }
}
@media (max-width: 575.98px) {
  h2 {
    font-size: 1.3rem;
  }
  .card-body .row > div {
    margin-bottom: 0.7rem;
  }
  .table th, .table td {
    font-size: 0.9rem;
    padding: 0.4rem;
  }
}
</style>
